import React from 'react'
import { Helmet } from 'react-helmet-async';
import './MobileAppDevelopment.css'
import Services from './services/Services';

import heroImage from '../../Assets/mobile-app-development/Realistic_smartphone.png'
import frame1 from '../../Assets/mobile-app-development/Frame1.png'
import services from '../../Assets/mobile-app-development/Services.png'
import Testimonials from './Testimonials'

const MobileAppDevelopment = () => {
  return (
    <div id='mobile-app-development'>
      <Helmet>
        <title>Mobile App Development Services | iOS & Android Apps</title>
        <meta name="description" content="Expert mobile app development services for iOS and Android. Create custom mobile apps with innovative features and intuitive design." />
        <link rel="canonical" href="https://bastionex.net/mobile-app-development-services" />
      </Helmet>
      {/* Hero Section */}
      <div className='app-hero-container'>
        <div className='app-hero-bg'></div>
        <div className='app-hero'>
          <div className='app-hero-content'>
            <h1 style={{ color: '#0C8CE9' }}>Mobile App</h1>
            <h1>Development Services:</h1>
            <h3>Seamless, Scalable & Stunning Experiences</h3>
            <p>Your app is more than a product—it’s your brand in motion. We design fast, secure, and user-centric <strong>mobile software development company</strong> that align with your business goals and leave a lasting impression.</p>
          </div>
          <div className='app-hero-image'>
            <img src={heroImage} alt="Realsitic Silver Smartphone" />
          </div>
        </div>
      </div>

      <div className='app-container'>
        {/* Description */}
        <div className='app-description'>
          <div className='app-description-image'>
            <img src={frame1} alt="Frame1" />
          </div>
          <div className='app-description-content'>
            <p>Don’t let your app idea stay just an idea. With our custom app development services for mobile, partner with us to create a mobile experience that users love and remember.</p>
          </div>
        </div>

        {/* Services */}
        <div className='app-services'>
          <div className='services-left'>
            <h2>What we deliver</h2>
            <div className='services-grid'>
              <div className='service-item'>
                <div className='service-icon'>
                  <img src="./service-icon1.png" alt="Custom Mobile App Development" />
                </div>
                <div className='service-text'>
                  <h4>Custom Mobile App Development</h4>
                  <p>From ideation to deployment, we create fully customized mobile apps that align with your vision and user needs.</p>
                </div>
              </div>
              <div className='service-item'>
                <div className='service-icon'>
                  <img src="./service-icon2.png" alt="iOS & Android Development" />
                </div>
                <div className='service-text'>
                  <h4>iOS & Android Development</h4>
                  <p>We create cross-platform and native applications that run flawlessly on all of the main devices. </p>
                </div>
              </div>
              <div className='service-item'>
                <div className='service-icon'>
                  <img src="./service-icon3.png" alt="UI/UX Design for Mobile" />
                </div>
                <div className='service-text'>
                  <h4>UI/UX Design for Mobile</h4>
                  <p>Beautiful, intuitive interfaces that prioritize user experience without compromising brand identity.</p>
                </div>
              </div>
              <div className='service-item'>
                <div className='service-icon'>
                  <img src="./service-icon4.png" alt="API & Backend Integration" />
                </div>
                <div className='service-text'>
                  <h4>API & Backend Integration</h4>
                  <p>Our team ensures seamless integration with third-party services, secure databases, and cloud infrastructure.</p>
                </div>
              </div>
              <div className='service-item'>
                <div className='service-icon'>
                  <img src="./service-icon5.png" alt="App Testing & QA" />
                </div>
                <div className='service-text'>
                  <h4>App Testing & QA</h4>
                  <p>Rigorous testing to ensure speed, stability, and security before going live.</p>
                </div>
              </div>
              <div className='service-item'>
                <div className='service-icon'>
                  <img src="./service-icon6.png" alt="Post-Launch Support & Maintenance" />
                </div>
                <div className='service-text'>
                  <h4>Post-Launch Support & Maintenance</h4>
                  <p>We don’t just deliver—we stay with you. Regular updates, bug fixes, and ongoing improvements are part of the package.</p>
                </div>
              </div>
            </div>
          </div>
          <div className='services-right'>
            <img src={services} alt="Mobile app development illustration" />
          </div>
        </div>

        {/* Why Choose Us */}
        <div className='app-why-us'>
          <h2>Why Us?</h2>
          <div className='why-us-grid'>
            <div className='why-us-item'>
              <div className='why-us-icon'>
                <img src="./why-icon1.png" alt="Years of Experience in Full-Stack Mobile Development" />
              </div>
              <h4>Years of Experience in Full-Stack Mobile Development</h4>
              <p>We bring deep technical expertise to build fast, scalable, and future-ready mobile apps.</p>
            </div>

            <div className='why-us-item'>
              <div className='why-us-icon'>
                <img src="./why-icon2.png" alt="Dedicated in-house team" />
              </div>
              <h4>Dedicated In-House Team</h4>
              <p>Our in-house team ensures consistent quality, clear communication, and faster turnarounds.</p>
            </div>

            <div className='why-us-item'>
              <div className='why-us-icon'>
                <img src="./why-icon3.png" alt="Agile, Transparent Delivery Process" />
              </div>
              <h4>Agile, Transparent Delivery Process</h4>
              <p>Stay in the loop at every stage with our agile workflows and clear, milestone-based updates.</p>
            </div>

            <div className='why-us-item'>
              <div className='why-us-icon'>
                <img src="./why-icon4.png" alt="SEO-Ready & Mobile-First Approach" />
              </div>
              <h4>SEO-Ready & Mobile-First Approach</h4>
              <p>We design with performance in mind—mobile-first, search-optimized, and user-focused.</p>
            </div>

            <div className='why-us-item'>
              <div className='why-us-icon'>
                <img src="./why-icon5.png" alt="Clients Across India, Dubai, and Beyond" />
              </div>
              <h4>Clients Across India, Dubai, and Beyond</h4>
              <p>Trusted by businesses locally and globally, our work speaks across borders.</p>
            </div>

            <div className='why-us-item'>
              <div className='why-us-icon'>
                <img src="./why-icon6.png" alt="24/7 Support & Maintenance" />
              </div>
              <h4>24/7 Support & Maintenance</h4>
              <p>Our round-the-clock support keeps your app secure, updated, and always running smoothly.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Our Process */}
      <div className='app-process-container'>
        <div className='app-process'>
          <h2>Our Process</h2>
          <div className='process-flow'>
            <div className='process-step'>
              <div className='process-icon'>
                <img src="./process-icon1.png" alt="Discovery & Strategy" />
              </div>
              <h4>Discovery & Strategy</h4>
              <p>We understand your goals and user needs.</p>
            </div>

            <div className='process-arrow'>
              <img src="./black-right-arrow.png" alt="arrow" />
            </div>

            <div className='process-step'>
              <div className='process-icon'>
                <img src="./process-icon2.png" alt="Design & Prototyping" />
              </div>
              <h4>Design & Prototyping</h4>
              <p>Wireframes and high-fidelity prototypes.</p>
            </div>

            <div className='process-arrow'>
              <img src="./black-right-arrow.png" alt="arrow" />
            </div>

            <div className='process-step'>
              <div className='process-icon'>
                <img src="./process-icon3.png" alt="Development" />
              </div>
              <h4>Development</h4>
              <p>Agile sprints, clean code, fast builds.</p>
            </div>

            <div className='process-arrow'>
              <img src="./black-right-arrow.png" alt="arrow" />
            </div>

            <div className='process-step'>
              <div className='process-icon'>
                <img src="./process-icon4.png" alt="QA & Launch" />
              </div>
              <h4>QA & Launch</h4>
              <p>Rigorous testing and store submission.</p>
            </div>

            <div className='process-arrow'>
              <img src="./black-right-arrow.png" alt="arrow" />
            </div>

            <div className='process-step'>
              <div className='process-icon'>
                <img src="./process-icon5.png" alt="Support & Scale" />
              </div>
              <h4>Support & Scale</h4>
              <p>Post-launch updates, analytics, and scaling strategies.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials */}
      <div className='app-container'>
        <div className='app-testimonials'>
          <Testimonials />
        </div>
      </div>

      <div className='app-container'>
        <Services/>
</div>
    </div>
  )
}

export default MobileAppDevelopment